export default __webpack_public_path__ + "static/media/icon-select-white.bfbcd3ba.svg";